/** Extra vendor contacts: name/title + email rows (not a comma-delimited list). */
import {
  emptyVendorExtraContact,
  type MfgVendorExtraContact,
} from "@/lib/manufacturing/vendorExtraContacts";
import {
  ghostBtnClass,
  inputClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

export function VendorExtraContactsEditor(props: {
  contacts: MfgVendorExtraContact[];
  onChange: (contacts: MfgVendorExtraContact[]) => void;
  disabled?: boolean;
}) {
  const rows = props.contacts.length ? props.contacts : [emptyVendorExtraContact()];

  function patch(index: number, next: MfgVendorExtraContact) {
    const copy = rows.map((row, i) => (i === index ? next : row));
    props.onChange(copy);
  }

  function remove(index: number) {
    const copy = rows.filter((_, i) => i !== index);
    props.onChange(copy.length ? copy : [emptyVendorExtraContact()]);
  }

  return (
    <div className="sm:col-span-2">
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-semibold">Extra contacts</span>
        <button
          type="button"
          className={ghostBtnClass}
          disabled={props.disabled}
          onClick={() => props.onChange([...rows, emptyVendorExtraContact()])}
        >
          Add contact
        </button>
      </div>
      <p className="mt-0.5 text-[11px] text-gray-500">
        Name or title plus email. Add as many rows as you need.
      </p>
      <div className="mt-1 space-y-2">
        {rows.map((row, i) => (
          <div key={i} className="flex flex-wrap items-end gap-2">
            <label className="min-w-[8rem] flex-1 text-xs">
              <span className="font-medium">Name / title</span>
              <input
                className={`${inputClass} mt-0.5 w-full`}
                value={row.name}
                disabled={props.disabled}
                placeholder="AP, billing, Jane…"
                onChange={(e) => patch(i, { ...row, name: e.target.value })}
              />
            </label>
            <label className="min-w-[10rem] flex-1 text-xs">
              <span className="font-medium">Email</span>
              <input
                className={`${inputClass} mt-0.5 w-full`}
                value={row.email}
                disabled={props.disabled}
                placeholder="name@vendor.com"
                inputMode="email"
                autoComplete="off"
                onChange={(e) => patch(i, { ...row, email: e.target.value })}
              />
            </label>
            <button
              type="button"
              className={`${ghostBtnClass} mb-0.5`}
              disabled={props.disabled || (rows.length === 1 && !row.name && !row.email)}
              onClick={() => remove(i)}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
